module.exports = __webpack_public_path__ + "img/guilt.31a0e54d.svg";